import { Component, ViewChild, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { AppPageComponent } from '../../shared/ui';
import { Product, InOutStock, ProductFilter } from '../shared/models';
import { ProductsFilterSheetComponent } from '../shared/ui';
import { ProductListService } from '../shared/services';
import { StoreHelper, Store, UserService, AppStateService } from '../../shared/services';
import { TopLevelComponent, HeaderAction } from '../../shared/models';

@Component({
    styles: [require('./product-list.component.scss')],
    template: require('./product-list.component.pug')
})
export class ProductListComponent extends TopLevelComponent implements OnDestroy {
    @ViewChild(AppPageComponent) appPage;
    @ViewChild(ProductsFilterSheetComponent) productsFilterSheetComponent;

    fg = new FormGroup({});
    products$: Observable<Product[]>;
    allLocationsSelected: boolean = true;
    loading = true;
    authorized = true;

    private _preloaderSubs: Subscription;
    private _productFilter: ProductFilter;
    private _filterReady: boolean = false;
    private _searchAction = { id: 'search', icon: 'search' };


    constructor(
        private _appStateService: AppStateService,
        public _productListService: ProductListService,
        public _router: Router,
        _store: Store,
        _storeHelper: StoreHelper,
        _userSvc: UserService
    ) {
        super(_store, _storeHelper, _userSvc);
        this.headerTitle = 'Inventory View';
        this.headerActions = [this._searchAction];

        //Hide back action in header section
        this._appStateService.changeBackActionValue(false);

        this.subscribeToHeaderActions(this._reactToHeaderAction);
    }

    ngOnDestroy() {
        if( this._preloaderSubs)
            this._preloaderSubs.unsubscribe();
    }

    onFilterChanged(filter: ProductFilter) {
        this._productFilter = filter;

        if (this._productFilter.locationsSelection.locations.length > 0) {
            this._loadProducts();

        } else {

            this._resetProductData();
            this.empty = true;
            setTimeout(() => this.productsFilterSheetComponent.toggle(), 1500);

            if (this._filterReady) {
                this.productsFilterSheetComponent.toggle();
            }

            this._filterReady = true;
        }
    }

    editInventory(product: Product) {
        this._router.navigate(['/inventory/inventory-detail', product.id]);
    }

    private _reactToHeaderAction(action: HeaderAction) {
        if (action.id === this._searchAction.id && this.authorized) {
            this.productsFilterSheetComponent.toggle();
        }
    }

    private _getProducts() {
        let that = this;
        this.empty = false;
        this.appPage.activatePreloader();
        this.loading = true;

        this.products$ = this._productListService.getProducts(this._productFilter);
        this._preloaderSubs = this.products$.subscribe(res => {
            that.appPage.deactivatePreloader();
            this.empty = res.length <= 0;

            if (this.empty) {
                setTimeout(() => that.productsFilterSheetComponent.toggle(), 1500);
            }
        },
        err => {
                this.authorized = this.userService.userHasAccess(err);
                this.appPage.deactivatePreloader();
                this.loading = false;
        },
        () => that.loading = false);

        if (this._filterReady) {
            this.productsFilterSheetComponent.toggle();
        }

        this._filterReady = true;
    }

    private _getStockInformation() {
        this._productListService.getStockInformation(this._productFilter.locationsSelection)
            .subscribe(
            (inOutStock: InOutStock) => {
                this.productsFilterSheetComponent.setInventoryOptions(inOutStock.inStock, inOutStock.outStock);
            },
            error => console.log(error)
            );
    }

    private _loadProducts() {
        this._getProducts();
        this._getStockInformation();
    }

    private _resetProductData() {
        this.products$.subscribe(i => i.splice(0));
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/product-list/product-list.component.ts